module.exports = __webpack_public_path__ + "images/emoji/wave.58855ea8165a90d727df.png";